import type { RouteRecordRaw } from '~/types/router';

export const nestRoutes = (): any[] => {
  const router = useRouter();
  const rawRoutes = router.getRoutes();
  const routes: RouteRecordRaw[] = rawRoutes.map((route) => {
    return {
      path: route.path,
      name: route.name,
      meta: route.meta as any,
      children: [],
      props: route.props,
    };
  });
  const routeMap = new Map<string, any>();
  routes.sort((a, b) => {
    const aPath = a.path.split('/').length;
    const bPath = b.path.split('/').length;
    return aPath - bPath == 0 ? a.meta.sort - b.meta.sort : aPath - bPath;
  });
  for (const route of routes) {
    const perPath = route.path.split('/');
    if (perPath.length === 1) continue;

    if (perPath.length > 2) {
      const parentRoute = routeMap.get(perPath[1]);
      parentRoute.children.push(route);
    } else {
      routeMap.set(perPath[1], route);
    }
  }
  return Array.from(routeMap.values());
};
